export enum ManPowerState {
    LIST = 'list',
    VIEW = 'view',
    NEW = 'new',
    EDIT = 'edit'
}